<template>
  <div>
    <div class="tabs is-boxed">
      <ul>
        <router-link :to="{ name: 'client-bets-redpipe' }" active-class="is-active" tag="li"><a>{{"bets.tabs.redpipe" | translate}}</a></router-link>
        <router-link :to="{ name: 'client-bets-flg' }" active-class="is-active" tag="li"><a>{{"bets.tabs.flg" | translate}}</a></router-link>
        <router-link :to="{ name: 'client-bets-hdraces' }" active-class="is-active" tag="li"><a>{{"bets.tabs.hdraces" | translate}}</a></router-link>
        <router-link :to="{ name: 'client-bets-bk' }" active-class="is-active" tag="li"><a>{{"bets.tabs.bk" | translate}}</a></router-link>
      </ul>
    </div>

    <router-view />
  </div>
</template>
<script>
  export default {
    name: 'client-bets'
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/client/bets/index.vue